import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem 5%',
    fontSize: theme.size.sm,
    color: theme.palette.textLight,
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexWrap: 'wrap'
  },

  item: {
    display: 'flex',
    flexDirection: 'column'
  },

  label: {
    fontSize: theme.size.sm,
    color: theme.palette.textLight,
    marginBottom: '3px',
    textTransform: 'uppercase'
  },

  row: {
    flexBasis: '50%',

    '& > :first-child': {
      marginBottom: '1.5rem'
    }
  },

  dropdown: {
    justifyContent: 'flex-start',
    marginBottom: '0'
  },

  team: {
    height: '100%'
  }
}))

export default useStyles
